import { api, post, postFile } from '../../service';
import { DIALOG_ADD, FILE_COPY } from '../../libs/enum';

const defaultPath = () => [{ labelName: '全部分类', level: 0, labelId: 0 }];
const defaultLabelForm = () => ({ parentId: 0, name: '' });
const defaultSearch = () => ({ offset: 0, count: 50 });
const defaultState = () => ({
    labelDialog: {
        visible: false,
        type: DIALOG_ADD,
    },
    labelForm: defaultLabelForm(),
    canRename: { show: false, name: '' },
    fileDialog: {
        visible: false,
        type: FILE_COPY,
    },
    search: defaultSearch(),
    total: 0,
    list: [],
    selection: [], // 选中的文件列表
    path: defaultPath(), // 分类路径
});

const moduleResource = {
    namespaced: true,
    state: defaultState(),
    getters: {
        lastLevel: state => {
            const last = state.path[state.path.length - 1];
            return last;
        },
    },
    actions: {
        resetState({ commit }) {
            commit('resetState');
        },
        async getFileList({ commit }, data) {
            const res = await post(api.resource.fileList, data);
            commit('changeList', {
                totalCount: res.totalCount,
                labels: res.files,
            });
        },
        async getLabelList({ commit }, data) {
            const res = await post(api.resource.labelList, data);
            commit('changeList', res);
        },
        async createLabel({ commit, dispatch, getters, state }) {
            const lastLevel = getters.lastLevel;
            const parentId = lastLevel.labelId;
            const params = { ...state.labelForm, parentId };
            await post(api.resource.createLabel, params);
            commit('changeLabelDialog', { visible: false });
            dispatch('changeSearch', defaultSearch());
        },
        async uploadFile({ dispatch, getters }, data) {
            const lastLevel = getters.lastLevel;
            let formData = new FormData();
            formData.append('labelId', lastLevel.labelId);
            formData.append('video', data);
            await postFile(api.resource.upload, formData);
            dispatch('changeSearch', defaultSearch());
        },
        async deleteFiles({ dispatch }, data) {
            await post(api.resource.deleteFiles, data);
            dispatch('changeSearch', defaultSearch());
        },
        async deleteLabels({ dispatch, getters }, data) {
            await post(api.resource.deleteLabels, data);
            const lastLevel = getters.lastLevel;
            dispatch('getLabelList', {
                labelId: lastLevel.labelId,
                offset: 0,
                count: 50,
            });
        },
        async renameFile({ dispatch }, data) {
            await post(api.resource.renameFile, data);
            dispatch('changeSearch', defaultSearch());
            dispatch('changeCanRename', { show: false, name: '' });
        },
        async renameLabel({ dispatch }, data) {
            await post(api.resource.renameLabel, data);
            dispatch('changeSearch', defaultSearch());
            dispatch('changeCanRename', { show: false, name: '' });
        },
        async moveFiles({ dispatch }, data) {
            await post(api.resource.moveFiles, data);
            dispatch('changeSearch', defaultSearch());
            dispatch('changeFileDialog', { visible: false });
        },
        async copyFiles({ dispatch, getters }, data) {
            await post(api.resource.copyFiles, data);
            const lastLevel = getters.lastLevel;
            dispatch('getFileList', {
                labelId: lastLevel.labelId,
                offset: 0,
                count: 50,
            });
            dispatch('changeFileDialog', { visible: false });
        },
        async search({ commit }, data) {
            const res = await post(api.resource.search, data);
        },
        changeLabelDialog({ commit }, data) {
            commit('changeLabelDialog', data);
        },
        changeCanRename({ commit }, data) {
            commit('changeCanRename', data);
        },
        changeFileDialog({ commit }, data) {
            commit('changeFileDialog', data);
        },
        clearPath({ commit, dispatch }) {
            commit('clearPath');
            dispatch('changeSearch', defaultSearch());
            dispatch('changeSelection', []);
        },
        pushPath({ commit, dispatch }, data) {
            commit('pushPath', data);
            dispatch('changeSearch', defaultSearch());
            dispatch('changeSelection', []);
        },
        popPath({ commit, dispatch }) {
            commit('popPath');
            dispatch('changeSearch', defaultSearch());
            dispatch('changeSelection', []);
        },
        changeSelection({ commit }, data) {
            commit('changeSelection', data);
        },
        changeSearch({ commit, dispatch, getters, state }, data) {
            commit('changeSearch', data);
            const lastLevel = getters.lastLevel;
            const params = { ...state.search, labelId: lastLevel.labelId };
            lastLevel.level === 2
                ? dispatch('getFileList', params)
                : dispatch('getLabelList', params);
        },
    },
    mutations: {
        resetState(state) {
            Object.assign(state, defaultState());
        },
        changeList(state, data) {
            const { totalCount, labels } = data;
            state.total = totalCount;
            state.list = labels;
        },
        changeLabelDialog(state, data) {
            Object.assign(state.labelDialog, data);
            if (!data.visible) {
                state.labelForm = defaultLabelForm();
            }
        },
        changeCanRename(state, data) {
            Object.assign(state.canRename, data);
        },
        changeFileDialog(state, data) {
            Object.assign(state.fileDialog, data);
        },
        clearPath(state) {
            state.path = [...defaultPath()];
        },
        pushPath(state, data) {
            state.path.push(data);
        },
        popPath(state) {
            state.path.pop();
        },
        changeSelection(state, data) {
            state.selection = data;
        },
        changeSearch(state, data) {
            Object.assign(state.search, data);
        },
    },
};

export default moduleResource;
